function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
      <path fill="#fff" d="M9.667 14.2a.8.8 0 000 1.6h10.666a.8.8 0 100-1.6H9.667z"></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15 .867C7.194.867.867 7.194.867 15c0 7.806 6.327 14.133 14.133 14.133 7.806 0 14.133-6.327 14.133-14.133C29.133 7.194 22.806.867 15 .867zM2.467 15C2.467 8.078 8.078 2.467 15 2.467S27.533 8.078 27.533 15 21.922 27.533 15 27.533 2.467 21.922 2.467 15z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
